<template lang="pug">
  .button-container(v-fade)
    button.button(
      :class=" { 'button--gradient' : isGradient, 'button--contrast' : isContrast, 'button--with-arrow' : withArrow }",
      v-if="!isLink"
    ) {{ buttonText }}
    a.button.js-scroll(
      :class=" { 'button--gradient' : isGradient, 'button--contrast' : isContrast, 'button--with-arrow' : withArrow}",
      v-if="isLink",
      :href="link",
      data-speed="800"
    ) {{ buttonText }}
    
</template>

<script>
export default {
  name: "Button",
  props: {
    isGradient: {
      type: Boolean,
      required: false
    },
    withArrow: {
      type: Boolean,
      required: false
    },
    isLink: {
      type: Boolean,
      required: false
    },
    buttonText: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: false
    },
    isContrast: {
      type: Boolean,
      required: false
    }
  }
};
</script>

<style lang="scss">
@import "../styles/main.scss";
$border: 4px;

.button {
  display: block;
  margin: 0 auto;
  font-family: $font-fmbolyarpro;
  line-height: 1.4;
  color: $color-text--contrast;
  position: relative;
  border: none;
  cursor: pointer;
  z-index: 1;
  border-radius: 50px;
  box-sizing: border-box;
  text-decoration: none;
  background-color: transparent;
  transition: $button-transition;
  font-size: 14px;
  width: 201px;
  padding: 14px 4px 13px;

  @include from("sm") {
    font-size: 16px;
    width: 220px;
    padding: 16px 12px 13px;
  }
  @include from("xl") {
    font-size: 26px;
    width: 351px;
    height: 78px;
    padding: 25px 28px 23px;
  }

  &--contrast {
    color: $color-text;

    &:before,
    &:after {
      content: "";
      background-image: radial-gradient(
        188.58px at 11.27% 100%,
        #6a592b 0%,
        #e9d691 52.23%,
        #cab555 100%
      );
      position: absolute;
      width: calc(100% + #{$border * 2});
      height: calc(100% + #{$border * 2});
      left: -$border;
      top: -$border;
      border-radius: 50px;
      z-index: -2;
      transition: $button-transition;
    }

    &:after {
      background: #fff;
      width: 100%;
      height: 100%;
      z-index: -1;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50px;
    }

    &:hover {
      color: $color-text--contrast;

      &:before {
        background-image: radial-gradient(
          188.58px at 11.27% 100%,
          #6a592b 0%,
          #e9d691 52.23%,
          #cab555 100%
        );
      }
      &:after {
        opacity: 0;
      }
    }
  }

  &--gradient {
    background: url("../assets/button-bg.png") no-repeat;
    background-size: contain;

    &:before {
      content: "";
      background: radial-gradient(
        188.58px at 11.27% 100%,
        #6a592b 0%,
        #e9d691 52.23%,
        #cab555 100%
      );
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      border-radius: 40px;
      z-index: -2;
      transition: $button-transition;
      opacity: 0;
    }

    &:hover {
      &:before {
        opacity: 1;
      }
    }
  }

  &--with-arrow {
    &:after {
      position: absolute;
      bottom: -40%;
      left: 50%;
      content: url("../assets/button-arrow.svg");
      width: 94px;
      height: 20px;
      opacity: 0;
      transform: translate(-150%, 30%);
      transition: $button-arrow-transition;
      pointer-events: none;
      touch-action: none;

      &:focus {
        outline: none;
      }
    }

    &:hover {
      &:after {
        opacity: 1;
        transform: translate(-50%, 30%);
      }
    }
  }

  &--wide {
    width: 100%;
    height: 44px;
    padding: 6px 28px 9px;
    font-size: 20px;
  }

  &--narrow {
    width: 157px;
    height: 38px;
    font-size: 17px;
    padding: 7px 28px 7px;

    @include from("sm") {
      width: 232px;
      height: 53px;
      font-size: 20px;
      padding: 13px 28px 15px;
    }
  }

  &:disabled {
    filter: grayscale(100%);
  }
}
</style>
